<div class="page-header">
    <h2>Frequently Asked Questions</h2>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<div class="container pt-24">

    <div class="faq-container"> <!-- ✅ THIS FIX -->

        <!-- LEFT SIDEBAR -->
        <div class="faq-sidebar">
            <ul>
                <li *ngFor="let topic of topics">
                    <a (click)="scrollTo(topic.key)" [class.active]="activeTopic === topic.key">
                        {{ topic.key }}
                    </a>
                </li>
            </ul>
        </div>

        <!-- RIGHT CONTENT -->
        <div class="faq-content">

            <div *ngFor="let topic of topics; let ti = index">

                <h3 [id]="topic.key">{{ topic.key }}</h3>

                <div *ngFor="let faq of $any(topic.value); let qi = index" class="accordion-card">

                    <div class="accordion-header" (click)="toggleFaq(ti, qi)">

                        <i class="pi" [ngClass]="isOpen(ti, qi) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>

                        <span class="question" [ngClass]="{ 'expanded': isOpen(ti, qi) }">
                            {{ faq.faqQuestion }}
                        </span>

                    </div>

                    <div class="accordion-body" *ngIf="isOpen(ti, qi)">
                        <div class="faq-answer" [innerHTML]="cleanHtml(faq.faqAnswer)"></div>
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
<!-- CLOSE BUTTON -->
<div class="faq-close-container">
    <button class="close-btn" (click)="onClose()">Close</button>
</div>